module.exports = __webpack_public_path__ + "img/team_active.d2b93ac0.png";